import React from 'react';
import {Col, Row} from 'antd';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import HorizontalBarChart from '../../../../components/admin/reports/charts/HorizontalBarChart';
import DonutChart from '../../../../components/admin/reports/charts/DonutChart';

export default function DemographicsSection({dateFrom, dateTo}) {
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_PATIENTS_DEMOGRAPHICS,
        params: {date_from: dateFrom, date_to: dateTo},
        dataDefault: {},
    });

    const ageData = data?.age_distribution || [];
    const genderData = data?.gender_distribution || [];
    const conditionData = data?.medical_condition_distribution || [];
    const stateData = data?.state_distribution || [];

    return (
        <Row gutter={[16, 0]}>
            <Col xs={24} lg={12}>
                <ReportChartCard title="Distribuição por Idade" loading={isLoading} isEmpty={!ageData.length}>
                    <HorizontalBarChart data={ageData} dataKey="count" nameKey="age_range"/>
                </ReportChartCard>
            </Col>
            <Col xs={24} lg={12}>
                <ReportChartCard title="Distribuição por Gênero" loading={isLoading} isEmpty={!genderData.length}>
                    <DonutChart data={genderData} dataKey="count" nameKey="gender"/>
                </ReportChartCard>
            </Col>
            <Col xs={24} lg={12}>
                <ReportChartCard title="Distribuição por Condição Médica" loading={isLoading} isEmpty={!conditionData.length}>
                    <HorizontalBarChart data={conditionData} dataKey="count" nameKey="condition"/>
                </ReportChartCard>
            </Col>
            <Col xs={24} lg={12}>
                <ReportChartCard title="Distribuição por Estado" loading={isLoading} isEmpty={!stateData.length}>
                    <HorizontalBarChart data={stateData} dataKey="count" nameKey="state"/>
                </ReportChartCard>
            </Col>
        </Row>
    );
}
